import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import ReactDOM from 'react-dom/client';
import { store } from 'reduxStore/appStore';
import { fetchAndProcessLoggedUser, resetBootstrapRetryGuard } from 'reduxStore/auth/asyncActions';

import { App } from './App';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);

// recompute dialog positions on every dispatch (hacky way)
store.subscribe(() => {
  window.dispatchEvent(new Event('resize'));
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 0);
});

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root');
  const root = ReactDOM.createRoot(container!);
  root.render(<App />);
});

window.addEventListener('pageshow', () => {
  resetBootstrapRetryGuard();
  store.dispatch(fetchAndProcessLoggedUser());
});
